module.exports = __webpack_public_path__ + "static/media/london-11.8cf781fb.jpg";